<!-- <div
  class="show-more-container"
  cdkDragBoundary="app-workbook-container"
  id="dragableCompSearch"
  cdkDrag
  (click)="searchWorksheet()"
>
  <i class="fa-solid fa-magnifying-glass"></i>
</div> -->

<div *ngIf="flexSheetService.worksheetPageModel?.gridColumnCount > 1" class="show-more-container"
     cdkDragBoundary="app-workbook-container" id="dragableCompColumn" cdkDrag>
    <div *ngIf="isColumnPaginationOpen" class="paginations">
        <input (keydown.enter)="jumpToPaginatedGrid('Col')" placeholder="Jump to..." [(ngModel)]="jumpToCol"/>
        <!-- page options -->
        <div class="page-options">
            <div class="page-option" [ngClass]="{
          active:
          flexSheetNavigationService.getSheetPagination().currentGridColumn == page.gridColumn
        }" *ngFor="
          let page of flexSheetNavigationService.getSheetPagination().columnPaginationOptions;
          let i = index
        " (click)="navigatePaginatedColumns(page.gridColumn)">
                <a>{{ page.text }}</a>
            </div>
        </div>
    </div>

    <div class="links flex flex-row justify-start items-center">
        <a title="Previous Page" [ngClass]="{
        disable: flexSheetNavigationService.getSheetPagination()?.currentGridColumn == 0
      }" class="show-more" (click)="flexSheetNavigationService.showPreviousPage(true)">
            <!--showPreviousPage-->
            <i class="fa-solid fa-arrow-left"></i>
        </a>
        <div (click)="onToggleColumnPagination()" class="page-info flex flex-row justify-center items-center">
            <div>
                {{flexSheetNavigationService.getSheetPagination().columnText}}
                <i *ngIf="!isColumnPaginationOpen" class="fa-regular fa-chevron-up"></i>
                <i *ngIf="isColumnPaginationOpen" class="fa-regular fa-chevron-down"></i>
            </div>
        </div>
        <a title="Next Page" [ngClass]="{
        disable:
        flexSheetNavigationService.getSheetPagination()?.currentGridColumn ==
          flexSheetService.worksheetPageModel?.gridColumnCount - 1
      }" class="show-more" (click)="flexSheetNavigationService.showNextPage(true)">
            <!--showNextPage-->
            <i class="fa-solid fa-arrow-right"></i>
        </a>
    </div>
</div>

<div cdkDragBoundary="app-workbook-container" class="show-more-container" id="dragableCompRow" cdkDrag>
    <div *ngIf="isRowPaginationOpen" class="paginations">
        <input (keydown.enter)="jumpToPaginatedGrid('Row')" placeholder="Jump to..." [(ngModel)]="jumpToRow"/>
        <!-- page options -->
        <div class="page-options">
            <div class="page-option" [ngClass]="{
          active:
          flexSheetNavigationService.getSheetPagination().currentGridRow == page.gridRow
        }" *ngFor="
          let page of flexSheetNavigationService.getSheetPagination().rowPaginationOptions;
          let i = index
        " (click)="navigatePaginatedRows(page.gridRow)">
                <a>{{ page.text }}</a>
            </div>
        </div>
    </div>
    <div class="links flex flex-row justify-start items-center">
        <a (click)="searchWorksheet()"
           data-copilot="workbook-btn-search"
           matTooltip="Search" [ngClass]="{
        isRowPaginationExists:
          flexSheetService.worksheetPageModel?.gridRowCount > 1
      }">
            <i class="fa-solid fa-magnifying-glass"></i>
        </a>

        @if(flexSheetService.worksheetPageModel?.gridRowCount > 1){
        <a title="Previous Page" [ngClass]="{
        disable: flexSheetNavigationService.getSheetPagination()?.currentGridRow == 0
        }" class="show-more" (click)="flexSheetNavigationService.showPreviousPage()">
      <!--showPreviousPage-->
      <i class="fa-solid fa-arrow-up"></i>
    </a>
    <div (click)="onToggleRowPagination()" class="page-info flex flex-row justify-start items-center">
      <div>
        {{flexSheetNavigationService.getSheetPagination().rowText}}
        <i *ngIf="!isRowPaginationOpen" class="fa-regular fa-chevron-up"></i>
        <i *ngIf="isRowPaginationOpen" class="fa-regular fa-chevron-down"></i>
      </div>
    </div>
    <a title="Next Page" [ngClass]="{
        disable:
        flexSheetNavigationService.getSheetPagination()?.currentGridRow ==
        flexSheetService.worksheetPageModel?.gridRowCount - 1
        }" class="show-more" (click)="flexSheetNavigationService.showNextPage()">
      <!--showNextPage-->
      <i class="fa-solid fa-arrow-down"></i> </a>}
    </div>
</div>


<div class="flexsheet-notification" *ngIf="flexSheetService.isWorkbookSetUpdated && !flexSheetService?.isReadonly" cdkDrag>
    This spreadsheet has been updated<span *ngIf="
      flexSheetService.workbookSetLastUpdatedBy &&
      flexSheetService.workbookSetLastUpdatedBy.FirstName
    ">
    by
    {{ flexSheetService?.workbookSetLastUpdatedBy?.FirstName }}
    {{ flexSheetService?.workbookSetLastUpdatedBy?.LastName }}</span>.<span><a (click)="refresh()" data-copilot="workbook-btn-refresh">Refresh</a></span>
</div>

<div *ngIf="
    !flexSheetService?.isReadonly &&
    flexSheetService?.getCurrentWorkBook().isSourceFileApplicable == true &&
    flexSheetService?.getCurrentWorkBook().isPlaceHolder == false
  " class="contextual-toolbar" cdkDrag>
    <ul class="action control-tooltip">
        <li (click)="configureWorksheetPlaceHolder()" matTooltip="Configuration Setting">
            <i class="fa-regular fa-gear"></i>
        </li>
        <li *ngIf="flexSheetService?.getCurrentWorkBook().isPlaceHolder == false" (click)="removeSourceFileCommand()"
            matTooltip="Delete">
            <i class="fa-regular fa-trash"></i>
        </li>
    </ul>
</div>

<!--<div *ngIf="flexSheetService.unSavedCount>0" cdkDrag>-->
<!--  <i class="fal fa-spinner fa-spin" style="position: absolute;z-index: 10;top: 6px;left: 6px;}"></i>-->
<!--</div>-->
<!---->
<div *ngIf="flexSheetService.unSavedCount > 0" style="position: absolute; z-index: 10; top: 0; left: 0;"
     class="loadingio-spinner-spin-xszz6xox5v8">
    <div class="ldio-jg3u13yb15">
        <div>
            <div></div>
        </div>
        <div>
            <div></div>
        </div>
        <div>
            <div></div>
        </div>
        <div>
            <div></div>
        </div>
        <div>
            <div></div>
        </div>
        <div>
            <div></div>
        </div>
        <div>
            <div></div>
        </div>
        <div>
            <div></div>
        </div>
        <div>
            <div></div>
        </div>
    </div>
</div>
<!--<div class="flexsheet-notification" *ngIf="flexSheetService.unSavedCount>0" cdkDrag>
  Saving...
&lt;!&ndash;  <strong>{{flexSheetService.unSavedCount}}</strong> Cell(s)&ndash;&gt;
</div>-->
<div class="excelbook" style="position: relative">
    <div class="row flex flex-col" id="flexsheetContainerTest">
        <div #flexSheetHost
             class="full-grow-no-shrink-no-basis wj-control wj-content wj-flexsheet"
             [class.hide]="flexSheetService?.getCurrentWorkBook().isPlaceHolder || flexSheetService?.getCurrentWorkSheet()?.isPlaceHolder">
        </div>

        <app-virtual-place-holder *ngIf="
        (flexSheetService?.getCurrentWorkBook().isPlaceHolder == false &&
          flexSheetService?.getCurrentWorkSheet()?.isPlaceHolder == true) ||
        flexSheetService.getCurrentWorkBook().isPlaceHolder == true
      " class=" full-grow-no-shrink-no-basis "></app-virtual-place-holder>

        <div class="flexsheetContainerTest-tab flex flex-row">
            <button [matMenuTriggerFor]="worksheetMenu" class="no-animation-btn worksheet-dropdown-menu" mat-button>
                <i class="fa-solid fa-ellipsis-vertical"></i>
            </button>

            <mat-menu #worksheetMenu="matMenu" [overlapTrigger]="false" class="m-t-10 activity-menu workbook-menu">
                <button (click)="onWorksheetChange(i)" [ngClass]="{ active: flexSheet?.selectedSheetIndex == i }"
                        *ngFor="let worksheet of flexSheetService.worksheets; let i = index" [attr.data-cy]="worksheet.name"
                        analyticsAction="menu-btn" mat-menu-item>
                    <div class="flex flex-row justify-start items-center">
                        <span>{{ worksheet.name }}</span>
                    </div>
                </button>
            </mat-menu>

            <mat-tab-group *ngIf="flexSheet"
                           class="tab-containers flex flex-row justify-start items-center full-grow-no-shrink-no-basis "
                           (selectedIndexChange)="onWorksheetChange($event)"
                           [selectedIndex]="flexSheet.selectedSheetIndex">
                <mat-tab *ngFor="let worksheet of flexSheetService.worksheets; let i = index">
                    <ng-template mat-tab-label>
                        <span [attr.data-copilot]="'worksheet-' + worksheet.name">{{ worksheet.name }}</span>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>

    <!-- the status bar -->
    <div class="row status text-right" style="padding-right: 10px">Ready</div>
</div>

<wj-menu style="display: none" #ctxMenu [header]="'Context Menu'" [selectedValuePath]="'cmd'"
         [dropDownCssClass]="'ctx-menu spreadsheet-dropdown-menu'"
         (itemClicked)="flexSheetCellMenuService.onCellMenuClick(ctxMenu)" (contextmenu)="disableContextMenu($event)">
    <wj-menu-item [cmd]="closeMenu"> Close</wj-menu-item>
    <wj-menu-separator></wj-menu-separator>
    <ng-container *ngFor="let menuItem of flexSheetCellMenuService.cellMenus">
        <wj-menu-item [cmd]="menuItem" *ngIf="menuItem.cmd != 'Separator'">
            {{ menuItem.label }} <i [class]="menuItem.iconClass"></i>
        </wj-menu-item>
        <wj-menu-separator *ngIf="menuItem.cmd == 'Separator'"></wj-menu-separator>
    </ng-container>
</wj-menu>
